<template>
  <div style="padding: 0 15px;" @click="toggleClick">
    <i v-show="!isShow" class="el-icon-s-fold hamburger" />
    <i v-show="isShow" class="el-icon-s-unfold hamburger" />
  </div>
</template>

<script>
export default {
  name: 'Hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShow: false
    }
  },
  methods: {
    toggleClick() {
      this.isShow = !this.isShow
      this.$emit('toggleClick')
    }
  }
}
</script>

<style scoped>
.hamburger {
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  color: #4E5C6C;
  font-size: 22px;
}
</style>
